import React from 'react';

export default props => (
  <svg
    {...props}
    viewBox="0 0 150 150"
    style={{
      enableBackground: 'new 0 0 150 150',
    }}
    xmlSpace="preserve"
  >
    {props.children}
    <path
      fill="#FAF5EF"
      d="m45.4 62 3.8-2.2a42.6 42.6 0 0 1-15.8-16.2c-8-13.9-9-30.4-9.1-35.7l-3.8 2.2c0 5.3 1.1 21.8 9 35.8 4.1 7 9.4 12.5 15.8 16.2Z"
    />
    <path fill="#fff" d="m45.5 21 3.8-2.2-28-16L17.5 5l28 16Z" />
    <path
      fill="#FAF5EF"
      d="M17.5 5v1.6c0 .3-.2 5.6 1 13.2.6 4.5 1.6 8.9 2.9 13 1.6 5.2 3.6 10 6 14.2 4.6 8.1 10.7 14.3 18 18.5v-3.4a42.6 42.6 0 0 1-15.8-16.2c-8-14-9-30.5-9.1-35.7l25 14.3v-3.4L17.5 5Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.5}
      d="m49.3 18.8-28-16L17.5 5s-.8 11.4 3.3 25.8 11.7 27.3 24.5 34.7l3.9-2.2v-3.4s-8.3-4.7-13.3-12.3-9.8-17.8-11.4-35l21 11.9 3.8-2.2v-3.5Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M75.1 64.5 7 103.8 75 143l68.2-39.3-68-39.2Z"
    />
    <path fill="none" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="m78.2 72.9-3.1-1.8-3 1.8" />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.53 6.53"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m66.4 76.1-53.7 31"
    />
    <path fill="none" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="m9.9 108.7-3 1.7 3 1.8" />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.5 6.5"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M15.5 115.4 69 146.3"
    />
    <path fill="none" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="m71.8 147.9 3.1 1.7 3-1.7" />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.53 6.53"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m83.6 144.6 53.7-30.9"
    />
    <path fill="none" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="m140.1 112 3-1.7-3-1.8" />
    <path
      fill="none"
      stroke="#000"
      strokeDasharray="0 0 6.5 6.5"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M134.5 105.3 81 74.5"
    />
    <path
      fill="#fff"
      d="M97.6 113c-1.1 1-2.5 2-4.1 3a42.2 42.2 0 0 1-37.1 0c-1.7-1-3.1-2-4.2-3-5.8-5.6-4.4-12.9 4-17.7a42.2 42.2 0 0 1 37.1 0c8.7 4.8 10 12.1 4.3 17.7Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M97.6 113c-1.1 1-2.5 2-4.1 3a42.2 42.2 0 0 1-37.1 0c-1.7-1-3.1-2-4.2-3-5.8-5.6-4.4-12.9 4-17.7a42.2 42.2 0 0 1 37.1 0c8.7 4.8 10 12.1 4.3 17.7Z"
    />
    <path
      fill="#FAF5EF"
      fillRule="evenodd"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M101 105.8v4.7c-.2 4-3 8-8.3 10.9a40.7 40.7 0 0 1-37.2-1c-5-3.2-7.3-7.1-7.2-11.2l.4-4c-.2 4 2 7.3 7 10.4 10 6.3 27.1 5.8 37 .8 5.8-2.9 8.1-6.6 8.4-10.6Z"
    />
    <path
      fill="#FAF5EF"
      fillRule="evenodd"
      d="m92.5 102-.1 3c-.2 2.3-2 4.7-5.5 6.5-7 3.5-17.7 3.2-24.2-.5-3.2-1.9-4.7-4.3-4.6-6.8l.2-2.8c-.2 2.4 1.4 4.8 4.6 6.7 6.4 3.8 17.2 4 24.2.6 3.5-1.8 5.3-4.2 5.4-6.6Z"
    />
    <path
      fill="#fff"
      d="M89.8 106.7c-.7.7-1.6 1.3-2.6 1.9-6.5 3.5-17 3.5-23.6 0-1-.6-2-1.3-2.6-2-3.7-3.4-2.8-7.9 2.6-10.9 6.4-3.5 17-3.5 23.5 0 5.5 3 6.4 7.5 2.7 11Z"
    />
    <path d="M75.4 93c4.6 0 8.8 1.1 11.8 2.8 3 1.7 4.8 4 4.8 6.3s-1.7 4.7-4.8 6.4c-3 1.7-7.2 2.7-11.8 2.7s-8.9-1-12-2.7c-3-1.7-4.7-4-4.7-6.4s1.8-4.6 4.8-6.3c3-1.7 7.2-2.7 11.9-2.7m0-.5c-4.6 0-9 1-12.2 2.8-3.2 1.8-5 4.2-5 6.7s1.8 5 5 6.8c3.3 1.8 7.6 2.8 12.2 2.8s8.8-1 12-2.8c3.3-1.8 5-4.2 5-6.8s-1.7-5-5-6.7a25.3 25.3 0 0 0-12-2.8Z" />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeWidth={0.5}
      d="M68.8 102s2.7 2.2 6.5 2.2 6.6-2.1 6.6-2.1V85.4l-13 .2v16.5Z"
    />
    <path fill="#FAF5EF" d="m45.3 65.5 3.9-2.2v-3.4L45.4 62v3.4Zm.2-41 3.8-2.2v-3.5L45.5 21v3.5Z" />
    <path fill="#fff" d="M69.3 101.7c2.5 1.5 8 2.5 8-5v-6.1l-8-1.5v12.6Z" />
    <path fill="#fff" d="M37.6 23.3S35 91 75.6 91V28.9l-38-5.6Zm76 0s2.7 67.8-38 67.8V28.9l38-5.6Z" />
    <path fill="#FAF5EF" d="M113.6 23.3s2.7 67.8-38 67.8c0 0 14.9-3.8 14.9-27.7s.5-21.2.5-21.2l22.6-19Z" />
    <path
      fill="#fff"
      d="M102.4 6.8a59.6 59.6 0 0 0-53.8 0c-14.8 8.5-14.7 22.4.2 31 14.9 8.5 39 8.5 53.8 0 14.8-8.6 14.7-22.5-.2-31Z"
    />
    <path
      fill="#FAF5EF"
      d="M120.9 84.5a9.4 9.4 0 0 1-2.5.5 11.2 11.2 0 0 1-2.9 0l-.9-.2-.9-.2-.9-.3a19.6 19.6 0 0 1-2.8-1l-1-.5-1.2-.6-8.4-5-3.9 2.3c.3.1 8.2 4.7 8.5 5l1 .5 1.1.5a21 21 0 0 0 2.9 1l.9.3.9.2a14 14 0 0 0 4.9 0 10.8 10.8 0 0 0 3.2-1.2l3.8-2.2-1.8.9Z"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="m54 52.5 4-1.8c1.8-.8 4.2-.4 6.8 1.3 5.2 3.3 9 9.5 9 16.3-.2 2.9-1.4 4.8-3.2 5.6l-3.9 2c1.8-.8 2-2.6 2.1-5.5.3-5.7-3.7-13-8.9-16.4-2.6-1.6-4.1-2.3-5.9-1.5Z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M54.3 52.3c-4.3 1.8-4.9 8.5-1.4 15 3.5 6.4 9.8 10.2 14 8.4 4.3-1.8 5-8.5 1.4-15-3.5-6.4-9.7-10.2-14-8.4Z"
    />
    <path
      fill="#FAF5EF"
      d="m60.3 55.3-1.6 5-5-2.9 4.1 6.8-1.3 5.5 3.8-2.1 4.6 6.8-1.8-7.3 4.7-1.1-5.8-3.8-1.7-7Zm44.4-23.6a25.2 25.2 0 0 1-5.2 3.7c-13 7-34 7-47 0-2.2-1.2-4-2.5-5.4-3.8-7.4-7-5.6-16 5.2-21.9 13-7 34-7 47 0 11 6 12.8 15 5.4 22Z"
    />
    <path
      fill="#F4EEE6"
      d="M104.2 31.8a24.8 24.8 0 0 1-5.2 3.9 51.7 51.7 0 0 1-46.7 0 25.2 25.2 0 0 1-5.3-4c1.4-1.4 3.1-2.7 5.2-3.9a51.7 51.7 0 0 1 46.7 0c2.1 1.2 3.9 2.6 5.3 4Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M113.6 22s3.2 69-38 69c-41 0-38-69-38-69"
    />
    <path
      fill="#FAF5EF"
      fillRule="evenodd"
      d="M135 56.8V59a47.5 47.5 0 0 1-.5 7.7c0 .9-.2 1.9-.4 2.9l-.1.7a76.1 76.1 0 0 1-2 7.1l-1 2.4v.1l-1.3 2.4c-1.4 2.1-3 3.8-4.8 4.9l-3.9 2.2c-4.6 2.7-10.7 2-18-2.1L95.6 83v-3.5l7.6 4.4.8.5-6.4-3.8-2-1.1 3.9-2.2 2 1.1a1010.3 1010.3 0 0 0 7.5 4.4l1 .5a21 21 0 0 0 3.8 1.3l1 .2a14 14 0 0 0 4.8 0l1.1-.2c6.5-5.8 7.5-19.2 7.6-23.9l-25-14.4V43l3.8-2.2 28 16Zm-16 29h-.1a10.1 10.1 0 0 1-3.2 1.3h-.3a10 10 0 0 0 3.5-1.3Z"
    />
    <path
      fill="#FAF5EF"
      d="M135 58.5v-1.7l-3.8 2.2v2.3a47.5 47.5 0 0 1-.5 7.7 70 70 0 0 1-.4 2.9l-.2.8a76.1 76.1 0 0 1-1.9 7l-1 2.4v.1l-1.4 2.4c-1.3 2.2-3 3.8-4.8 4.9l3.9-2.2c1.8-1.1 3.4-2.8 4.8-5a31.7 31.7 0 0 0 4.3-12l.1-.6a58 58 0 0 0 1-10.6v-.7Z"
    />
    <path fill="#fff" d="m135 56.8-3.8 2.2-28-16.1 3.8-2.2 28 16Z" />
    <path
      fill="#FAF5EF"
      d="M130.1 72.7c-.7 3.7-1.7 6.9-3 9.5a16.4 16.4 0 0 1-6 7.3c-4.7 2.7-10.8 2-18-2.2L95.5 83v-3.5l7.6 4.4c6.4 3.7 11.7 4.3 15.8 2 8-4.8 9.1-20.1 9.3-25.2l-25-14.4V43l28 16v1.8c0 .2.1 5.7-1 12Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="m107 40.7 28 16s.5 5.2-.9 13-3.5 15.1-12 19.3c0 0-3 2.5-9.2 2s-17.4-8-17.4-8v-3.5l3.9-2.2s8.4 5.2 13.4 7 7.8.3 7.8.3 6.6-3.5 7.6-24l-25-14.3V43l3.9-2.2Z"
    />
    <ellipse cx={75.5} cy={22.3} fill="none" stroke="#000" strokeWidth={0.5} rx={38} ry={21.9} />
  </svg>
);
